var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-switcher"},_vm._l((_vm.supportedLanguages),function(lang){return _c('span',{key:lang,class:{ 'is-selected': _vm.isCurrentLanguage(lang) },on:{"click":function($event){return _vm.changeLanguage(lang)}}},[_vm._v("\n    "+_vm._s(lang)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a98108c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheLanguageSwitcher.vue
// module id = null
// module chunks = 